import React from 'react';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import {Checkbox, FormControlLabel} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {FieldRenderProps} from 'react-final-form-hooks';

import {UserOption} from '@pluto/users';
import {
    UserStatuses,
    OnChange,
} from './UserTypes';
import './UserDetails.scss';

interface UserDetailsProps {
    userDetails: UserOption;
    rolesField: FieldRenderProps;
    statusesField: FieldRenderProps;
    valid: boolean;
    roleErrorMessage?: string[];
    pushRouteToHistory: () => void;
    onChangeRole: (roleField: FieldRenderProps, role: string) => OnChange;
    onChangeStatus: (statusField: FieldRenderProps, status: string) => OnChange;
    onUpdateHandler: () => void;
    formatDate: (date: string) => string;
}

export default function UserDetails(props: UserDetailsProps) {
    const {
        userDetails,
        rolesField,
        statusesField,
        valid,
        roleErrorMessage,
        pushRouteToHistory,
        onChangeRole,
        onChangeStatus,
        onUpdateHandler,
        formatDate,
    } = props;
    const {
        name,
        email,
        createdAt,
    } = userDetails;
    
    const formattedDate = formatDate(createdAt);
    
    return (
        <div>
            <h2>{name}</h2>
            <div className="user-details">
                <div className="user-details__email">
                Email: <span>{email}</span>
                </div>
                <div className="user-details__created">
                Created on: <span>{formattedDate}</span>
                </div>
                <div className="user-details__status">
                    <div>Status:</div>
                    <div className="user-details__status__radios">
                        <div>
                            <Radio
                                checked={statusesField.input.value === 'ACTIVE'}
                                onChange={onChangeStatus(statusesField, 'ACTIVE')}
                                name="ACTIVE"
                            />
                            {UserStatuses.Active}
                        </div>
                        <div className="user-details__status__radios__deactivated">
                            <Radio
                                checked={statusesField.input.value === 'DEACTIVATED'}
                                onChange={onChangeStatus(statusesField, 'DEACTIVATED')}
                                name="DEACTIVATED"
                            />
                            {UserStatuses.Deactivated}
                        </div>
                    </div>
                </div>
                <div className="user-details__roles">
                    <FormControl>
                        <div>
                        User Roles:
                        </div>
                        <FormGroup>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={rolesField.input.value.includes('admin')}
                                        onChange={onChangeRole(rolesField, 'admin')}
                                        name="admin"
                                    />
                                )}
                                label="Administrator"
                            />
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={rolesField.input.value.includes('qcOperator')}
                                        onChange={onChangeRole(rolesField, 'qcOperator')}
                                        name="qcOperator"
                                    />
                                )}
                                label="QC Operator"
                            />
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={rolesField.input.value.includes('contentOpsCoordinator')}
                                        onChange={onChangeRole(rolesField, 'contentOpsCoordinator')}
                                        name="contentOpsCoordinator"
                                    />
                                )}
                                label="Content Ops Coordinator"
                            />
                            <div className="user-details__roleError">
                                <span>{roleErrorMessage}</span>
                            </div>
                        </FormGroup>
                    </FormControl>
                </div>
                <div className="user-details__buttons">
                    <Button
                        className="user-details__buttons_cancel"
                        onClick={pushRouteToHistory}
                        variant="contained"
                    >
                    Cancel
                    </Button>
                    <Button
                        disabled={!valid}
                        onClick={onUpdateHandler}
                        variant="contained"
                    >
                    Update
                    </Button>
                </div>
            </div>
        </div>
    );
}

UserDetails.defaultProps = {
    roleErrorMessage: '',
};
